import resolveConfig from "tailwindcss/resolveConfig";

// @ts-ignore
import * as tailwindConfig from "@moment/tailwind-config";

export const config = resolveConfig(tailwindConfig);
